const SvgCodeSelected = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_12701_57657)">
        <path
          d="M9.00005 1.7998C5.02385 1.7998 1.80005 5.0236 1.80005 8.9998C1.80005 12.976 5.02385 16.1998 9.00005 16.1998C12.9762 16.1998 16.2 12.976 16.2 8.9998C16.2 5.0236 12.9762 1.7998 9.00005 1.7998ZM13.0243 7.624L8.48825 12.16C8.37545 12.2728 8.22305 12.3358 8.06405 12.3358C7.90505 12.3358 7.75205 12.2728 7.63985 12.16L5.56805 10.0882C5.33345 9.8536 5.33345 9.4744 5.56805 9.2398C5.80265 9.0052 6.18185 9.0052 6.41645 9.2398L8.06405 10.8874L12.1758 6.77561C12.4104 6.54101 12.7896 6.54101 13.0243 6.77561C13.2589 7.0102 13.2589 7.3894 13.0243 7.624Z"
          className="fill-primary"
        />
      </g>
      <defs>
        <clipPath id="clip0_12701_57657">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgCodeSelected;
